/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SubscriptionUserControllerApplyPackageTopUpMutationResponse,
  SubscriptionUserControllerApplyPackageTopUpPathParams,
  SubscriptionUserControllerApplyPackageTopUp401,
  SubscriptionUserControllerApplyPackageTopUp402,
} from '../types/SubscriptionUserControllerApplyPackageTopUp.ts';

function getSubscriptionUserApplyPackageTopUpUrl(
  productId: SubscriptionUserControllerApplyPackageTopUpPathParams['productId'],
) {
  const res = { method: 'POST', url: `/api/user/telegram/subscriptions/package/top-up/${productId}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/subscriptions/package/top-up/:productId}
 */
export async function subscriptionUserApplyPackageTopUp(
  productId: SubscriptionUserControllerApplyPackageTopUpPathParams['productId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SubscriptionUserControllerApplyPackageTopUpMutationResponse,
    ResponseErrorConfig<
      SubscriptionUserControllerApplyPackageTopUp401 | SubscriptionUserControllerApplyPackageTopUp402
    >,
    unknown
  >({ method: 'POST', url: getSubscriptionUserApplyPackageTopUpUrl(productId).url.toString(), ...requestConfig });
  return res.data;
}
